import { decodeBase64Url, encodeBase64Url } from '@toruslabs/metadata-helpers';
import { klona } from 'klona/json';

function base64toJSON(b64str) {
  return JSON.parse(decodeBase64Url(b64str));
}
function jsonToBase64(json) {
  return encodeBase64Url(JSON.stringify(json));
}
const htmlToElement = html => {
  const template = window.document.createElement("template");
  const trimmedHtml = html.trim(); // Never return a text node of whitespace as the result
  template.innerHTML = trimmedHtml;
  return template.content.firstChild;
};
function cloneDeep(object) {
  try {
    return klona(object);
  } catch {
    return JSON.parse(JSON.stringify(object));
  }
}
function isObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
function hasProperty(value, key) {
  return isObject(value) && key in value;
}

export { base64toJSON, cloneDeep, hasProperty, htmlToElement, isObject, jsonToBase64 };
